module.exports = __webpack_public_path__ + "img/MicrosoftTeams-image_homes.21d80248.png";